/**
 * ─────────────────────────────────────────────────────────────────────────────
 * ONE-TIME ORDER BUMP — edit everything about the offer here.
 * ─────────────────────────────────────────────────────────────────────────────
 * `upsellVariantId` is the Shopify variant added alongside the selected tier
 * when the visitor accepts the offer.
 */
export const upsellVariantId = '49945662128370'

/** Seconds the offer stays available inside the pop-up. */
export const upsellDurationSeconds = 120

export const upsell = {
  eyebrow: 'Aspetta! Questa offerta la vedi solo adesso',
  title: 'Metodo Concentrazione in 10 minuti',
  image: 'https://cdn.magicpatterns.com/uploads/as889eQMh2j1PewnEffrNA/upsell_neurokids_1024.webp',
  imageAlt: 'Quaderno di attività stampabili del Metodo Concentrazione in 10 minuti',
  price: '19,99 €',
  comparePrice: '59,00 €',
  /** Numeric price, used to report the order value to Meta. */
  priceValue: 19.99,
  acceptLabel: 'Sì, aggiungilo al mio ordine',
  declineLabel: 'No, grazie, vado al pagamento',
  reassurance: 'Accesso immediato · stessa email del tuo kit',
}
